// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"41c67525","297":"d53f07de","643":"58014595","787":"a086dd7f"}[chunkId] + ".chunk.js";
};